
import logoSuzukiSmall from '@assets/logos/suzuki-logo-small.png'
import logoSuzuki from '@assets/logos/suzuki-logo.png'
import { ClientConfigInfo, FILTER_TYPES, METADADATA_LOAD, SurveyResponsesTab } from './configCommons'
import { DASHBOARDS, DASHBOARDS_CONFIGS } from '../dashboard/dashboardCommons'
import { commonFilterCriticalMomentDefault, commonFilterCriticalMoments } from '../dashboard/dashHelper'
import { omoikaneSuzuki } from '../omoikane/omoikaneSuzuki'

import deafultHelpDefinition from '../help/defaultHelp'

const suzukiMetadataDefault = [
    METADADATA_LOAD.GEOS,
    METADADATA_LOAD.CRITICAL_MOMENTS
]

export const suzukiConfigs: ClientConfigInfo = {
    vocBackendUrl: 'https://suzuki-epsilon-backend-voc.limetropy.com/api/',
    lcmBackendUrl: 'https://suzuki-epsilon-backend-core.limetropy.com/api/',
    //vocBackendUrl: 'http://localhost:9000/api/',
    publicUrl: undefined,
    logoSmall: logoSuzukiSmall,
    logo: logoSuzuki,
    filtersFromDateSubstract: 2,
    filtersToDateSubstract: 1,
    decimals: undefined,
    supportsInternationalization: false,
    filters: [FILTER_TYPES.DATES, FILTER_TYPES.GEOS, FILTER_TYPES.CRITICAL_MOMENTS,FILTER_TYPES.CHANNELS],
    menuDashboards: [DASHBOARDS.DEFAULT],
    msExcelReportExt: 'xls',
    geosRootId: 1,
    logicalsRootId: 0,
    criticalMomentsRootId: 1,
    criticalMomentFilterType: 'select',
    actionPlans: {
        geoLeafLevel: 'DEALER',
        useWorstTags: true,
        useFreeActionPlans: false
    },
    sentimentCommentsIndicatorName: 'SENTIMENT_COMMENTS',
    omoikane: omoikaneSuzuki,
    useBackDashboards: false,
    metadata: [...suzukiMetadataDefault, METADADATA_LOAD.DYNAMIC_REPORT_FIELDS,METADADATA_LOAD.CHANNELS,],
    dashboards: {
        ...DASHBOARDS_CONFIGS.suzuki,
        default: DASHBOARDS_CONFIGS.suzuki[DASHBOARDS.DEFAULT]
    },
    useDefaultCriticalMoment: true,
    staticDashboards: {},
    surveyResponses: {
        url: 'survey-responses',
        type: 'get',//'post-context',
        tableColumns: undefined,
        tabs: [SurveyResponsesTab.ANSWERED, SurveyResponsesTab.NOT_ANSWERED],
    },
    alerts: {
            alertFilterFields:{
                enabled: true,
                alertId: true,
                surveyResponseId: true,
                customerServiceCode: true
            }
        },
    help: deafultHelpDefinition,
    surveyResponseStats:{
        showClientMode: true,
        clientModeMapping: (value: string) => {
                const mapping: Record<string, string> = {
                    'app': 'surveys.appWeb',
                    'web': 'surveys.base',
                };

                return mapping[value] || '-'; 
            },
        surveyResponseFilterFields: {
            enabled: true,
            clientName: true,
            customerServiceCode: true
        },
    }
   
    
}
